import { ScriptLoaderService } from '../../script-loader.service';

window.addEventListener('DOMContentLoaded', async () => {
  const scriptLoader = new ScriptLoaderService();
  const googleMapsApiUrl = 'https://maps.googleapis.com/maps/api/js?key={key}';

  const mapIcon: google.maps.Symbol = {
    path: 'M5.92666667,10.2866667 C5.92666667,7.97333333 7.74666667,6.09333333 10,6.09333333 C12.2533333,6.09333333 14.0733333,7.97333333 14.0733333,10.2866667 C14.0733333,12.6 12.2533333,14.4733333 10,14.4733333 C7.74666667,14.4733333 5.92666667,12.6 5.92666667,10.2866667 M0,10.2866667 C0,15.9666667 9.62666667,26.6666667 10,26.6666667 C10.3733333,26.6666667 20,15.9666667 20,10.2866667 C20,4.60666667 15.52,0 10,0 C4.48,0 0,4.60666667 0,10.2866667',
    fillColor: '#ffdc00',
    fillOpacity: 1,
    anchor: <google.maps.Point>{ x: 10, y: 27 },
    strokeWeight: 0,
    scale: 1.5,
  };

  const $mapElements =
    document.querySelectorAll<HTMLElement>('.cmp-google-map');
  if ($mapElements.length > 0) {
    // Get Google Maps API key from first map
    const apiKey = $mapElements.item(0).dataset['apiKey'];
    if (apiKey) {
      await scriptLoader.loadScript(googleMapsApiUrl.replace(/{key}/g, apiKey));

      Array.from($mapElements).forEach(($element) => {
        const $mapElement = $element.querySelector<HTMLElement>(
          '.cmp-google-map__map'
        );

        if ($mapElement) {
          const centre = $element.dataset['centre'];
          const zoom = $element.dataset['zoom'];
          const style = $element.dataset['style'];
          const markerTitle = $element.dataset['markerTitle'];
          if (centre && zoom) {
            let mapStyle: google.maps.MapTypeStyle[] | null = null;
            if (style && style.trim() !== '') {
              try {
                mapStyle = JSON.parse(style);
              } catch (e) {
                console.error(`[google-map] Exception parsing map styles:`);
                console.error(e);
              }
            }

            const coords = {
              lat: parseFloat(centre.split(',')[1]),
              lng: parseFloat(centre.split(',')[0]),
            };
            const map = new google.maps.Map($mapElement, {
              zoom: parseInt(zoom, 10),
              center: coords,
              styles: mapStyle,
              controlSize: 24,
              disableDefaultUI: true,
            });

            const marker = new google.maps.Marker({
              position: coords,
              map: map,
              icon: mapIcon,
              title: markerTitle,
            });
            if (markerTitle && markerTitle.trim() !== '') {
              const markerWindow = new google.maps.InfoWindow({
                content: `<div class="cmp-google-map__marker-title">${markerTitle}</div>`,
              });
              marker.addListener('click', () => {
                markerWindow.open({
                  anchor: marker,
                  map,
                });
              });
            }
          }
        }
      });
    }
  }
});
